module.exports = __webpack_public_path__ + "img/4.06d49f8a.jpg";